import type { AnalysisCardId } from "src-next/modules/clinical-insights/types/analysisTypes";

/**
 * Chave de sessão de um payload de análise.
 * Usa o período já aplicado (depois do debounce), não a data ainda instável.
 *
 * Buscas FHIR organizacionais não filtram profissional na rede: passe
 * `practitionerFilter` fixo (`org`) para reutilizar o mesmo bundle.
 * Questionários e protocolos enviam o profissional na query: a chave muda com ele.
 */
export function insightAnalysisCacheKey(parts: {
  analysisId: AnalysisCardId | string;
  organizationId: string;
  startDate?: string;
  endDate?: string;
  practitionerFilter?: string;
}): string | null {
  const organizationId = parts.organizationId.trim();
  if (!organizationId) return null;
  return [
    "clinical-insights",
    parts.analysisId,
    organizationId,
    parts.startDate ?? "",
    parts.endDate ?? "",
    parts.practitionerFilter ?? "all",
  ].join(":");
}

/** Bundle FHIR da organização, independente do filtro de profissional (client-side). */
export const INSIGHT_ORG_BUNDLE_PRACTITIONER = "org";
